import { Theme, css } from '@emotion/react';
import { ArrowSquareOut, Copy } from '@phosphor-icons/react';
import { Tooltip } from 'client/components/Tooltip';
import { Typography } from 'client/components/Typography';
import { Transition } from 'client/Theme';

export const InputIcon = ({
  isCopyTooltipOpen,
  icon,
  canCopy,
  openLinkInNewTab,
}: {
  isCopyTooltipOpen: boolean;
  icon?: JSX.Element;
  canCopy: boolean;
  openLinkInNewTab: string | null;
}) => {
  let action = null;
  let text = null;

  if (icon) action = icon;

  if (canCopy) {
    action = (
      <Tooltip open={isCopyTooltipOpen} title="Text copied to clipboard" align="center" hideArrow>
        <Copy size={24} />
      </Tooltip>
    );
    text = 'Copy';
  }

  if (openLinkInNewTab) {
    action = <ArrowSquareOut size={24} />;
    text = 'Open';
  }

  if (!action) return null;

  return (
    <div className="icon" css={iconStyle}>
      {text && <Typography variant="body2">{text}</Typography>}
      {action}
    </div>
  );
};

const iconStyle = (theme: Theme) => css`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 6px;
  top: 0;
  right: 0;
  padding: 0 16px;
  height: 100%;
  color: ${theme.color.grey[80]};
  pointer-events: none;

  transition: color ${Transition.basic};

  > p {
    transition: color ${Transition.basic};
  }
`;
